import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ConfirmationModal from 'Src/shared/modal/confirmation';
import session from 'Src/session';

class Original extends Component {
  static propTypes = {
    original: PropTypes.instanceOf(HTMLElement)
  };
  constructor (props) {
    super(props);
    const self = this;
    self.state = { moveTo: null };
    self.block = React.createRef();
    self.closeModal = self.closeModal.bind(self);
    self.onClick = self.onClick.bind(self);
  }
  componentDidMount () {
    const self = this;
    self.block.current.appendChild(this.props.original);
    //   入力画面等から同意のために戻ってきた場合、同意モーダルを自動で開く
    //   （入力画面等からsessionStorageの requiredAgreementKeyに値が設定されているときに動作）
    const agreementRequiredFunc = session.popRequiredAgreement();
    // トップが表示された時点で、すべてのセッション情報を削除
    session.removeAll();
    if (agreementRequiredFunc) {
      self.triggerConfirmation(agreementRequiredFunc);
    }
  }
  triggerConfirmation (functionKey) {
    const link = document.getElementById(`${functionKey}-link`);
    if (!link) {
      return;
    }
    link.click();
  }
  closeModal () {
    const self = this;
    self.setState({ moveTo: null });
  }
  onClick (event) {
    const self = this;
    const closestLink = (elem) => {
      if (!elem) {
        return null;
      }
      if (elem.href && elem.classList.contains('confirm-link')) {
        return elem;
      }
      return closestLink(elem.parentNode);
    };
    const linkElem = closestLink(event.target);
    if (!linkElem) {
      return;
    }
    event.preventDefault();
    self.setState({ moveTo: linkElem.href });
  }
  render () {
    const self = this;
    return (
      <div>
        <div ref={self.block} onClick={self.onClick} />
        {self.state.moveTo && (
          <ConfirmationModal
            title="個人情報の取扱について"
            onExited={self.closeModal}
            onConfirm={() => {
              session.agree();
              location.href = self.state.moveTo;
            }}
            checkText="同意する"
            checkAlign="center"
            cancelButton={false}
            submitButton="続ける"
            autoClose
          >
            <p className="mb-0">お客さまが入力された個人情報は、暗号化通信により保護されます。</p>
            <p>
              このサービスにより収集する個人情報は、水道の使用開始、使用中止の受付に必要な情報に限っています。収集した個人情報については、水道事業にかかる業務以外の目的には使用しません。
            </p>
            <p>上記事項をご確認の上、ご同意いただける方は下の「同意する」をチェックしてください</p>
          </ConfirmationModal>
        )}
      </div>
    );
  }
}
export default Original;
